import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { postAuthSocialCallback } from 'utils/api';
import { menu } from 'utils/constants';

const SUPPORTED_PROVIDERS = ['kakao', 'naver'];
const STATE_KEY = 'oauth_state';

const OAuthCallback = () => {
  const { provider } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('로그인 처리 중입니다...');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const run = async () => {
      if (!SUPPORTED_PROVIDERS.includes(provider)) {
        setMessage('지원하지 않는 소셜 로그인입니다.');
        return;
      }

      const code = searchParams.get('code');
      const stateFromQuery = searchParams.get('state');
      const error = searchParams.get('error');
      if (error) {
        setMessage('소셜 로그인이 취소되었거나 실패했습니다.');
        return;
      }
      if (!code) {
        setMessage('인증 코드가 없습니다.');
        return;
      }

      const expectedState = sessionStorage.getItem(STATE_KEY);
      sessionStorage.removeItem(STATE_KEY);
      if (!expectedState || expectedState !== stateFromQuery) {
        setMessage('유효하지 않은 요청입니다 (state 불일치).');
        return;
      }

      try {
        const res = await postAuthSocialCallback(provider, code);
        if (res.statusCode !== 200) {
          setMessage(res.message || '로그인에 실패했습니다.');
          return;
        }
        const results = res.results || {};
        if (results.login) {
          localStorage.setItem('token', results.token);
          localStorage.setItem('name', results.name);
          localStorage.setItem('plan', results.plan || 'free');
          localStorage.setItem('email', results.email || '');
          navigate(menu.analysis.estateObjectList.link, { replace: true });
        } else {
          sessionStorage.setItem(
            'oauth_signup',
            JSON.stringify({
              signupToken: results.signupToken,
              nickname: results.nickname,
              provider: results.provider,
            }),
          );
          navigate(menu.oauthSignup.link, { replace: true });
        }
      } catch (e) {
        const msg = e?.response?.data?.message || '로그인 처리에 실패했습니다.';
        setMessage(msg);
      }
    };

    run();
  }, [provider, searchParams, navigate]);

  return (
    <Container>
      <Message>{message}</Message>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Message = styled.div`
  font-size: 14px;
  color: #495057;
`;

export default OAuthCallback;
